exports = module.exports = require("../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n#home-reviews {\n       padding-top: 91px!important;\n\tbackground-color: #ffffff;\n\ttext-align: center;\n}\n\n#home-reviews > h1 {\n\tpadding-top: 0.5em;\n\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/reviews.component.css
// module id = ../../../../../src/app/reviews.component.css
// module chunks = main